<template>
    <div class="ponto-eletronico">
        <PageTitle icon="fa fa-calendar" main="Ponto eletrônico"
            sub="Ficha ponto valdiada \ Ficha ponto" />
        <div class="ponto-eletronico2">
            <b-card no-body>
                <b-tabs>                         
                    <b-tab title="Ficha ponto validada" active><PontoFichaPontoValidada/></b-tab>                    
                    <b-tab title="Ficha ponto Globus"><PontoConsultaFichaPonto /></b-tab>
                    <!--
                    <b-tab title="Horas Programado x Realizado"><PontoProgramadoRealizado /></b-tab>                                                    
                    -->
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import PontoFichaPontoValidada from '../flp_pontoeletronico/PontoFichaPontoValidada'
import PontoConsultaFichaPonto from '../flp_pontoeletronico/PontoConsultaFichaPonto'
//import PontoProgramadoRealizado from '../flp_pontoeletronico/PontoProgramadoRealizado'
export default {
    name: 'PontoEletronicoPrincipal',    
    components: { PageTitle, PontoFichaPontoValidada, PontoConsultaFichaPonto }
    
}
</script>

<style>

</style> 
